'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _components = require('../vue/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Customiser = function Customiser(el) {
  (0, _classCallCheck3.default)(this, Customiser);

  new _vue2.default({
    components: _components2.default
  }).$mount(el);
};

exports.default = Customiser;